var map = {
	"./amor-1.png": 2078,
	"./amor-2.png": 3121,
	"./amor-3.png": 3689,
	"./ancient_wyvern.gif": 8225,
	"./ancient_wyvern_dead.png": 4111,
	"./background.jpg": 8039,
	"./coin.png": 3881,
	"./crown.png": 9852,
	"./cursor.png": 7398,
	"./default-amor.png": 6755,
	"./default-item.png": 4137,
	"./default-shield.png": 7096,
	"./default-weapon.png": 2177,
	"./fire_wyvern.gif": 7206,
	"./fire_wyvern_dead.png": 1204,
	"./golem-canyon.png": 5387,
	"./golem.gif": 2923,
	"./golem_dead.png": 3490,
	"./ice_wyvern.gif": 4749,
	"./ice_wyvern_dead.png": 2642,
	"./leader_golem.gif": 1822,
	"./leader_golem_dead.png": 7162,
	"./necklace.png": 422,
	"./player-dead.png": 9636,
	"./player-fight.gif": 2508,
	"./player-fight.png": 7946,
	"./player.gif": 8937,
	"./player.png": 182,
	"./ring.png": 124,
	"./senior_golem.gif": 383,
	"./senior_golem_dead.png": 5305,
	"./shield-1.png": 943,
	"./shield-2.png": 8197,
	"./shield-3.png": 1459,
	"./shop.jpg": 9008,
	"./slime-field.png": 1117,
	"./undead_golem.gif": 3606,
	"./undead_golem_dead.png": 9284,
	"./village.jpg": 8954,
	"./weapon-1.png": 1845,
	"./weapon-2.png": 7190,
	"./weapon-3.png": 7596,
	"./wyvern-cave.png": 6660,
	"./wyvern.gif": 8496,
	"./wyvern_dead.png": 7564,
	"./빨간_슬라임.gif": 9770,
	"./빨간_슬라임_dead.png": 2916,
	"./슬라임.gif": 167,
	"./슬라임_dead.png": 401,
	"./킹_슬라임.gif": 3394,
	"./킹_슬라임_dead.png": 2502,
	"./파란_슬라임.gif": 2962,
	"./파란_슬라임_dead.png": 5780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8668;